/** Maps admin nav English labels → translation keys (namespace.key form from API). */
export const NAV_LABEL_I18N: Record<string, string> = {
  Overview: 'admin.nav.overview',
  'Tenant Master': 'admin.nav.tenant_master',
  Operations: 'admin.nav.operations',
  Onboarding: 'admin.nav.onboarding',
  'Service Hubs': 'admin.nav.service_modules',
  'Customer App': 'admin.nav.customer_app',
  'Finance & Reports': 'admin.nav.finance',
  Support: 'admin.nav.support',
  Settings: 'admin.nav.config',
  Dashboard: 'admin.nav.dashboard',
  'Users & Admins': 'admin.nav.users_admins',
  Tenants: 'admin.nav.tenants',
  'Subscription Plans': 'admin.nav.subscription_plans',
  'Dispatch Center': 'admin.nav.dispatch_center',
  'SOS Command': 'admin.nav.sos_command',
  Zones: 'admin.nav.zones',
  'Rental Management': 'admin.nav.rental_management',
  'Outstation Management': 'admin.nav.outstation_management',
  Partners: 'admin.nav.partners',
  'Partner Subscriptions': 'admin.nav.partner_subscriptions',
  'Document Review': 'admin.nav.document_review',
  Documents: 'admin.nav.documents',
  Transport: 'admin.nav.transport',
  Delivery: 'admin.nav.delivery',
  'On Demand': 'admin.nav.on_demand',
  Services: 'admin.nav.home_services',
  Taxi: 'admin.nav.taxi',
  Food: 'admin.nav.food',
  Grocery: 'admin.nav.grocery',
  Porter: 'admin.nav.porter',
  'Home Banners': 'admin.nav.home_banners',
  'Promos & Coupons': 'admin.nav.promos_coupons',
  Settlements: 'admin.nav.settlements',
  Reports: 'admin.nav.reports',
  Helpdesk: 'admin.nav.helpdesk',
  'Master Data': 'admin.nav.master_data',
  'Roles & Permissions': 'admin.nav.roles_permissions',
  'Roles & Privileges': 'admin.nav.roles_permissions',
  Notifications: 'admin.nav.notifications',
  'Payment Gateways': 'admin.nav.payment_gateways',
  'SMS Gateways': 'admin.nav.sms_gateways',
  'Locale & Currency': 'admin.nav.locale_currency',
  Translations: 'admin.nav.translations',
  'Translator Master': 'admin.nav.translations',
  'Site Settings': 'admin.nav.site_settings',
  'Audit Logs': 'admin.nav.audit_logs',
  'My Profile': 'admin.nav.my_profile',
  'Service Hub': 'admin.service_hubs',
  Vendor: 'admin.nav.partners',
};

export function navI18nKey(label: string, sectionId?: string): string {
  if (NAV_LABEL_I18N[label]) return NAV_LABEL_I18N[label];
  if (sectionId) return `admin.nav.${sectionId}`;
  return `admin.${label.toLowerCase().replace(/[^a-z0-9]+/g, '_')}`;
}
